import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { contactUrls } from "../../URL/ApplicationUrls";
import { Contact } from "../Contact";
import { objectWithIdNotFoundMessage } from "../../Messages/errorMessages";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchContact = (contactId: number | string | undefined) => {
  return useQuery<Contact, Error>({
    queryKey: namedQueryKeyWithId("contacts", contactId),
    queryFn: () => fetchContact(contactId),
    onError: () => {
      toast.error(objectWithIdNotFoundMessage(contactId, "Contact"));
    },
  });
};

const fetchContact = async (id: number | string | undefined) => {
  const { data: contact } = await axios.get<Contact>(contactUrls.contactWithId(id).apiUrl);
  return contact;
};
